/* eslint-disable react/style-prop-object */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, useCallback } from "react";
import mapboxgl from "mapbox-gl";
import { api } from "../../services/api";
import { MapaDiv, MapActionBtn } from "./styled";
import Menu from "../../components/Menu";
import Load from "../../components/Load";
import { useNavigate } from "react-router-dom";
import { MdMyLocation, MdDirectionsBus } from "react-icons/md";
import "./mapstyle.css";
import iconCar from "./images/iconCarro1.png";
// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from "worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker";

// Cria ícone SVG de ônibus frontal como data URL para markers do mapa
const createBusIconSVG = (color = '#76c24e') => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="${color}" stroke="white" stroke-width="2.5"/>
    <rect x="13" y="9" width="18" height="24" rx="3.5" fill="none" stroke="white" stroke-width="2"/>
    <rect x="15.5" y="12.5" width="13" height="8" rx="1.5" fill="rgba(255,255,255,0.9)"/>
    <circle cx="17" cy="27.5" r="2" fill="white"/>
    <circle cx="27" cy="27.5" r="2" fill="white"/>
    <rect x="20.5" y="9" width="3" height="4.5" rx="1" fill="rgba(255,255,255,0.5)"/>
  </svg>`;
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
};

// Cria popup HTML estilizado
const createPopupHTML = (buss_line_name, buss_line_tag, label2, unit_label) => {
  return `
    <div style="font-family:'Inter',-apple-system,sans-serif;min-width:220px;">
      <div style="font-size:15px;font-weight:700;color:#213f9a;margin-bottom:8px;">${unit_label || label2}</div>
      <div style="display:flex;align-items:center;gap:6px;padding:4px 0;font-size:12px;color:#495057;">
        <span style="color:#adb5bd;">Linha:</span> ${buss_line_name || '—'}
      </div>
      <div style="display:flex;align-items:center;gap:6px;padding:4px 0;font-size:12px;color:#495057;">
        <span style="color:#adb5bd;">Tag:</span> ${buss_line_tag || '—'}
      </div>
      <div style="display:flex;align-items:center;gap:6px;padding:4px 0;font-size:12px;color:#495057;">
        <span style="color:#adb5bd;">Frota:</span> ${label2 || '—'}
      </div>
      <div style="display:flex;align-items:center;gap:6px;padding:4px 0;font-size:12px;color:#495057;margin-bottom:8px;">
        <span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#76c24e;"></span>
        Em operação
      </div>
      <hr style="border:none;border-top:1px solid #ededed;margin:4px 0 8px;"/>
    </div>
  `;
};

mapboxgl.workerClass = MapboxWorker;
mapboxgl.accessToken =
  "pk.eyJ1IjoiY2hyaXN0aWFub2xpbm8iLCJhIjoiY2s5ZWhnY21zMDBmNDNscDRtNnplNnhqcCJ9.KYxz1mLRgnZdWur4i3k4IQ";
//token de exemplo na doc
const MapAllBus1 = () => {
  const navigate = useNavigate();
  const mapContainerRef = useRef(null);
  const locateClickCount = useRef(0);
  const locateClickTimer = useRef(null);

  const [map, setMap] = useState(null); // seta o mapa, padrao
  const [locations, setLocations] = useState([]); // seta a posicao inicial meio inutil
  const [markerUser, setMarkerUser] = useState(null); // marca posição do usuário
  const [load, setload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [formDirection, setFormDirection] = useState({});
  const [unidades, setUnidades] = useState();
  const [unidadesIcon, setUnidadesIcon] = useState([]);
  const [unitIsTrue, setUnitIsTrue] = useState(false);
  const [unitZoom, setUnitZoom] = useState(true);
  const [coordinatesUnit, setCoordinatesUnit] = useState([]);
  const [ccLogin, setCCLogin] = useState();

  const blsi = localStorage.getItem("BuslineShiftID");
  const address = JSON.parse(localStorage.getItem("addressListFix"));

  let ccid = localStorage.getItem("CoastCenterID");
  const urlCCID = new URL(window.location);
  const decodedStr = atob(urlCCID.searchParams.get("ccid"));

  if (ccid == undefined || ccid == null || ccid != decodedStr) {
    if (ccid !== decodedStr && decodedStr !== atob(null)) {
      localStorage.setItem("CoastCenterID", decodedStr);
    } else {
      localStorage.setItem("CoastCenterID", ccid);
    }
  }

  let ccid1 = localStorage.getItem("CoastCenterID");


//Salvo na variável formValues o que o usuário escolheu no dropdown de linha e viagem
const handleLineChange = (e) => {
  e.preventDefault();
  const { value, name } = e.target;
  setFormValues({ ...formValues, [name]: value });
};

//Salvo na variável formValues o que o usuário escolheu no dropdown de viagem
const handleViagemChange = (e) => {
  e.preventDefault();
  const { value, name } = e.target;
  setFormValues({ ...formValues, [name]: value });
};

  const getBusLocationRealTime = async () => {
    // pega informacao da posicao atual do busao
    try {
      const res = await api.get(`/busline/allbus?cost_center_id=${ccid1}`);
      console.log('allbus response:', res.status, res.data?.length || 0, 'unidades');
      setUnidades(res.data);
    } catch (error) {
      console.log('allbus error:', error);
    }
  };

  const DrawUnit = () => {
    if (!unidades || !map) return;
    if (!map.isStyleLoaded()) {
      // Aguarda style carregar e tenta novamente
      map.once('style.load', () => DrawUnit());
      return;
    }
    let features = [];

    const busIconUrl = createBusIconSVG('#76c24e');
    const img = new Image(45, 45);
    img.onload = () => {
      if (!map.isStyleLoaded()) return;
      if (!map.hasImage("custom-marker")) {
        map.addImage("custom-marker", img);
      }

      unidades.map((item) => {
        coordinatesUnit.push([
          parseFloat(item.longitude),
          parseFloat(item.latitude),
        ]);
        return features.push({
          type: "Feature",
          properties: item,
          geometry: {
            type: "Point",
            coordinates: [item.longitude, item.latitude],
          },
        });
      });

      // Remove source anterior se existir
      if (map.getLayer("places")) map.removeLayer("places");
      if (map.getSource("places")) map.removeSource("places");

      map.addSource("places", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: features,
        },
      });

      map.addLayer({
        id: "places",
        type: "symbol",
        source: "places",
        layout: {
          "icon-image": "custom-marker",
          "icon-allow-overlap": true,
        },
      });

      map.on("mouseenter", "places", () => {
        map.getCanvas().style.cursor = "pointer";
      });

      map.on("mouseleave", "places", () => {
        map.getCanvas().style.cursor = "";
      });

      map.on("click", "places", (e) => {
        map.getCanvas().style.cursor = "pointer";

        const coordinates = e.features[0].geometry.coordinates.slice();
        const buss_line_name = e.features[0].properties.buss_line_name;
        const buss_line_tag = e.features[0].properties.buss_line_tag;
        const label2 = e.features[0].properties.label2;
        const unit_label = e.features[0].properties.unit_label;
        const blsID = e.features[0].properties.buss_line_shift_id;

        while (Math.abs(e.lngLat.lng - coordinates[0]) > 200) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        const popupHTML = createPopupHTML(buss_line_name, buss_line_tag, label2, unit_label);
        const container = document.createElement("div");
        container.innerHTML = popupHTML;

        const btnViagem = document.createElement("button");
        btnViagem.innerText = "Ver Viagem";
        btnViagem.style.cssText = `
          width:100%;padding:8px 16px;background:linear-gradient(135deg,#213f9a,#3a5bc7);
          color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:600;
          font-family:'Inter',sans-serif;cursor:pointer;transition:all 150ms ease;
        `;
        btnViagem.onmouseenter = () => { btnViagem.style.transform = 'translateY(-1px)'; btnViagem.style.boxShadow = '0 4px 12px rgba(33,63,154,0.3)'; };
        btnViagem.onmouseleave = () => { btnViagem.style.transform = 'none'; btnViagem.style.boxShadow = 'none'; };
        btnViagem.addEventListener("click", () => {
          localStorage.setItem("BuslineShiftID", blsID);
          navigate("/mapa");
        });
        container.firstElementChild.appendChild(btnViagem);

        new mapboxgl.Popup({ offset: 20, maxWidth: '280px' })
          .setLngLat(coordinates)
          .setDOMContent(container.firstElementChild)
          .addTo(map);
      });

      if (unitZoom) {
        let bounds = coordinatesUnit.reduce(function (bounds, coord) {
          return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(coordinatesUnit[0], coordinatesUnit[0]));

        // Incluir localização do usuário no bounds
        const savedAddr = JSON.parse(localStorage.getItem("addressListFix"));
        if (savedAddr && savedAddr.length > 0 && savedAddr[0].coords) {
          bounds.extend([savedAddr[0].coords[0], savedAddr[0].coords[1]]);
        } else if (markerUser) {
          const userLngLat = markerUser.getLngLat();
          if (userLngLat.lng !== -47.4197) bounds.extend([userLngLat.lng, userLngLat.lat]);
        }

        map.fitBounds(bounds, { padding: 200, duration: 800 });
        setUnitZoom(false);
      }
    };
    img.src = busIconUrl;

    setUnitIsTrue(true);
  };

  const getCurrentLocationOfUser = () => {
    if (!markerUser) return;
    try {
      const savedAddress = JSON.parse(localStorage.getItem("addressListFix"));
      if (savedAddress && savedAddress.length > 0 && savedAddress[0].coords) {
        markerUser.setLngLat([savedAddress[0].coords[0], savedAddress[0].coords[1]]);
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            markerUser.setLngLat([
              position.coords.longitude,
              position.coords.latitude,
            ]);
          },
          (err) => console.log('Geolocation error:', err),
          { enableHighAccuracy: true, timeout: 5000 }
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

useEffect(() => {
    if (formValues.viagem) {
      localStorage.setItem("BuslineShiftID", formValues.viagem);
      return navigate("/mapa");
    }
  }, [formValues.viagem]);

  useEffect(() => {
    if (!map) {
      // se o mapa nao iniciar, forca a inicializacao
      setMap(
        new mapboxgl.Map({
          container: mapContainerRef.current,
          style: "mapbox://styles/mapbox/streets-v11",
          center: [-47.4197, -20.5418],
          zoom: 5,
        })
      );

      return;
    }

    setLocations([
      {
        type: "Feature",
        properties: {
          title: "Localizacao atual",
          description: "Onde o usuario esta no momento",
        },
        geometry: {
          coordinates: [-47.4197, -20.5418],
          type: "Point",
        },
      },
    ]);
    // Clean up on unmount
    return () => map.remove();
  }, [map]);

  useEffect(() => {
    if (!map) return;
    let element = "";
    // seta uma posicao inicial, na primeira vez

    if (!markerUser) {
      setMarkerUser(
        new mapboxgl.Marker((element = document.getElementById("you")))
          .setLngLat([-47.4197, -20.5418])
          .addTo(map)
      );
    }

    return () => {
      // remove a posicao para atualizar dps no mapa
      if (markerUser !== null) markerUser.remove();
    };
  }, [locations]);

  const centerOnUserLocation = () => {
    if (!map) return;
    const savedAddr = JSON.parse(localStorage.getItem("addressListFix"));
    if (savedAddr && savedAddr.length > 0 && savedAddr[0].coords) {
      if (markerUser) markerUser.setLngLat([savedAddr[0].coords[0], savedAddr[0].coords[1]]);
      map.flyTo({ center: [savedAddr[0].coords[0], savedAddr[0].coords[1]], zoom: 13, speed: 3 });
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        const coords = [pos.coords.longitude, pos.coords.latitude];
        if (markerUser) markerUser.setLngLat(coords);
        map.flyTo({ center: coords, zoom: 13, speed: 3 });
      });
    }
  };

  useEffect(() => {
    if (!map) return;
    if (unidades === undefined) return;
    if (!unidades || unidades.length === 0) {
      centerOnUserLocation();
      return;
    }
    if (unitIsTrue) {
      if (map.getLayer("places")) map.removeLayer("places");
      if (map.getSource("places")) map.removeSource("places");
    }
    if (unidadesIcon != null) {
      for (let a = unidadesIcon.length - 1; a >= 0; a--) {
        unidadesIcon[a].remove();
      }
    }
    setUnitIsTrue(false);
    DrawUnit();
  }, [unidades]);

  useEffect(() => {
    //se o mapa e o marcador n existir, ignora
    if (!map || !markerUser) return;
    const int = setInterval(() => {
      // chamadas das funcoes para atualizar a posicao
      getCurrentLocationOfUser();
    }, 1000);
    // limpa intervalo pra nao bugar a pag
    return () => {
      clearInterval(int);
    };
  }, [map, markerUser]);

  useEffect(() => {
    //se o mapa e o marcador n existir, ignora
    if (!map || !markerUser) return;

    setTimeout(() => {
      DrawUnit();
      getBusLocationRealTime();
    }, 1000);

    const int = setInterval(() => {
      // chamadas das funcoes para atualizar a posicao
      DrawUnit();
      getBusLocationRealTime();
    }, 30000);

    // limpa intervalo pra nao bugar a pag
    return () => {
      clearInterval(int);
    };
  }, [formValues.viagem, markerUser, blsi]);


  return (
    <>
      {load ? <Load /> : null}
      {
        <MapaDiv>
          <Menu transparent />
          <MapActionBtn
            top="60px"
            onClick={() => {
              locateClickCount.current += 1;
              if (locateClickTimer.current) clearTimeout(locateClickTimer.current);
              locateClickTimer.current = setTimeout(() => {
                const withZoom = locateClickCount.current >= 2;
                locateClickCount.current = 0;
                if (!map) return;
                const savedAddr = JSON.parse(localStorage.getItem("addressListFix"));
                const opts = { speed: 3 };
                if (withZoom) opts.zoom = 15;
                if (savedAddr && savedAddr.length > 0 && savedAddr[0].coords) {
                  const coords = [savedAddr[0].coords[0], savedAddr[0].coords[1]];
                  if (markerUser) markerUser.setLngLat(coords);
                  map.flyTo({ center: coords, ...opts });
                } else if (navigator.geolocation) {
                  navigator.geolocation.getCurrentPosition((pos) => {
                    const coords = [pos.coords.longitude, pos.coords.latitude];
                    if (markerUser) markerUser.setLngLat(coords);
                    map.flyTo({ center: coords, ...opts });
                  });
                }
              }, 300);
            }}
            aria-label="Centralizar na minha localização"
          >
            <MdMyLocation />
          </MapActionBtn>
          <MapActionBtn
            top="108px"
            onClick={() => {
              if (!map || !coordinatesUnit || coordinatesUnit.length === 0) return;
              const bounds = coordinatesUnit.reduce(
                (b, c) => b.extend(c),
                new mapboxgl.LngLatBounds(coordinatesUnit[0], coordinatesUnit[0])
              );
              const savedAddr = JSON.parse(localStorage.getItem("addressListFix"));
              if (savedAddr && savedAddr.length > 0 && savedAddr[0].coords) {
                bounds.extend([savedAddr[0].coords[0], savedAddr[0].coords[1]]);
              }
              map.fitBounds(bounds, { padding: 80, duration: 800 });
            }}
            aria-label="Centralizar nos veículos"
          >
            <MdDirectionsBus />
          </MapActionBtn>
          <div className="map-container" ref={mapContainerRef} />
          <div id="marked"></div>
          <div id="you" />
        </MapaDiv>
      }
    </>
  );
};

export default MapAllBus1;
